<template>
  <div>
    <top><p slot="center">个人中心</p></top>
    <div id="mylist">
      <div class="docItem" style="margin-top: 30px">
        <span class="left"><Icon type="ios-person" />我的账号</span>
        <span class="right">{{ formItem.loginName }}</span>
      </div>
      <div class="docItem">
        <span class="left"><Icon type="ios-copy" />我的备注名</span>
        <span class="right">{{
          formItem.name == null ? "暂无" : formItem.name
        }}</span>
      </div>
      <div class="docItem" style="margin-bottom: 20px">
        <span class="left"><Icon type="ios-call" />我的电话</span>
        <span class="right">{{
          formItem.tel == null ? "暂无" : formItem.tel
        }}</span>
      </div>
      <div class="docItem" style="margin-bottom: 20px">
        <span class="left"><Icon type="ios-lock" />登录密码</span>
        <span class="right" @click="openPassword = true">修改</span>
      </div>
      <div class="docItem" v-if="false" @click="openMy = true">
        <span class="left"><Icon type="ios-planet" />公司网站</span>
        <span class="right">深圳来源电子有限公司</span>
      </div>

      <div style="padding: 0 15px; text-align: center; margin-top: 30px">
        <Button type="text" @click="logOut">退出登录</Button>
      </div>
    </div>
    <Drawer
      placement="right"
      :closable="true"
      :mask="true"
      :draggable="false"
      width="100"
      v-model="openMy"
      title="公司官网"
    >
      <iframe
        height="100%"
        width="100%"
        src="http://www.ly-gps.com"
        frameborder="0"
      ></iframe>
    </Drawer>
    <Drawer
      placement="bottom"
      :closable="true"
      :mask="true"
      :draggable="false"
      height="350"
      v-model="openPassword"
      title="修改密码"
    >
      <my-password></my-password>
    </Drawer>
  </div>
</template>
<script>
import myPassword from "./password.vue";
import axios from "axios";
var oldPassword;
export default {
  data() {
    return {
      item: {},
      formItem: { name: "", tel: 123 },
      openMy: false,
      openPassword: false,
    };
  },
  components: {
    myPassword,
  },
  methods: {
    getSelfInfo() {
      axios({
        method: "post",
        url: "/personal/getPersonalInfo",
        data: {},
      }).then((res) => {
        console.log(res);
        this.formItem = {
          loginName: res.data.data.loginName,
          tel: res.data.data.tel,
          name: res.data.data.name,
          password: res.data.data.password,
        };
      });
    },
    setSelfInfo() {
      let params = new window.FormData();
      params.append("name", this.formItem.name);
      params.append("tel", this.formItem.tel);
      if (this.myImg.length > 0) {
        params.append("avatarFile", this.myImg[0].file);
      }
      axios({
        method: "post",
        url: "personal/updatePersonalInfo",
        data: params,
      }).then((res) => {
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.$Message.success({
            content: "修改成功",
            duration: 2,
          });
          this.modal = false;
          this.getUser();
        }
      });
    },
    submitSelf() {
      this.setSelfInfo();
    },
    clickButton() {
      this.$router.push({
        path: "/password",
      });
    },
    logOut() {
      axios({
        method: "post",
        url: axios.serverWeb + "/auth/signOut",
        data: {},
      }).then((res) => {
        localStorage.removeItem("phone");
        if (res.data.code == 200) {
          this.$router.push({
            path: "/login",
          });
        } else {
        }
      });
    },
  },
  mounted() {
    this.getSelfInfo();
  },
};
</script>
<style lang="">
#mylist .docItem {
  background: #fff;
  padding: 15px;
  margin-bottom: 4px;
}
#mylist .docItem span i {
  font-size: 24px;
  margin-right: 8px;
  color: #277dee;
}
#mylist .docItem .right {
  float: right;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/doc/doc.vue